import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/bk/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, bkSettings) {
    await Vue.http.post(`/api/bk/settings/byclient/${clientId}`, bkSettings);
    noty.success('Settings saved successfully');
  },
  async get(filter) {
    return (await Vue.http.post('/api/bk/bets/list', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/bk.service.js